import { RegenerateAISuggestionsMenuItem } from '@/modules/aiSuggestions/components/RegenerateAISuggestionsMenuItem';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

interface RegenerateSubtrustSuggestionsV2MenuItemProps {
  testamentaryEntityId: string;
  /** Called after the regeneration mutation returns successfully. */
  onCompleted?: () => void;
}

export function RegenerateSubtrustSuggestionsV2MenuItem({
  testamentaryEntityId,
  onCompleted,
}: RegenerateSubtrustSuggestionsV2MenuItemProps) {
  const { householdId } = useHouseholdDetailsContext();

  if (!householdId) return null;

  return (
    <RegenerateAISuggestionsMenuItem
      targetId={testamentaryEntityId}
      householdId={householdId}
      onCompleted={onCompleted}
      confirmation={{
        heading:
          'Are you sure you want to regenerate AI suggestions for this sub-trust?',
        body: 'Regenerating suggestions will remove existing suggestions. New suggestions will be generated from available documents.',
      }}
    />
  );
}
